import { render } from "./Accessibility.vue?vue&type=template&id=61ca718a&scoped=true"
import script from "./Accessibility.vue?vue&type=script&lang=js"
export * from "./Accessibility.vue?vue&type=script&lang=js"

import "./Accessibility.vue?vue&type=style&index=0&id=61ca718a&scoped=true&lang=scss"
import "./Accessibility.vue?vue&type=style&index=1&id=61ca718a&lang=css"

import exportComponent from "/home/forge/olyo.io/app-src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61ca718a"]])

export default __exports__